var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { value: "", "escape-close": "" },
      on: {
        input: function ($event) {
          return _vm.onModalInput($event)
        },
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v("Script JSON uploaden")]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      !_vm.file
                        ? _c(
                            "app-file-upload",
                            {
                              on: {
                                input: function ($event) {
                                  return _vm.onFile($event)
                                },
                              },
                            },
                            [_vm._v(" JSON bestand kiezen ")]
                          )
                        : _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.file = null
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "times" } }),
                              _vm._v(" " + _vm._s(_vm.file.name)),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Annuleren")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.file == null, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v("Bevestigen")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }